<main>
  <section class="upload-container">
    <form [formGroup]="yearOfStudyForm" class="fundAllocationsForm">
      <mat-form-field appearance="outline" class="fundAllocationsFormField">
        <mat-label>Year of study</mat-label>
        <mat-select formControlName="yearOfStudy">
          @for (year of docsYears; track year) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <button
      mat-flat-button
      color="primary"
      (click)="navigateToTranscriptUploads()"
    >
      Upload academic transcript
    </button>
  </section>

  <section>
    @if (hasDocument("Matric Certificate") || hasDocument("Academic Record")) {
      <section>
        <h2>Academic documentation</h2>
        <mat-divider class="divider"></mat-divider>
        <ng-container class="supporting-docs-container">
          @if (hasDocument("Matric Certificate")) {
            <section class="btn-tile">
              <section class="doc-type-view">
                <p class="support-text">Matric Certificate</p>
                <button
                  mat-flat-button
                  color="accent"
                  (click)="viewDocument('Matric Certificate')"
                >
                  View
                </button>
              </section>
              <section class="calculated-average">
                @if (averages.matric) {
                  <p class="average">
                    <strong>Average grade:</strong> {{ averages.matric }}%
                  </p>
                }
              </section>
            </section>
          }
          @if (hasDocument("Academic Record")) {
            <section class="btn-tile">
              <section class="doc-type-view">
                <p class="support-text">Academic Record</p>
                <button
                  mat-flat-button
                  color="accent"
                  (click)="viewDocument('Academic Record')"
                >
                  View
                </button>
              </section>
              <section class="calculated-average">
                @if (
                  averages.academicRecord !== undefined &&
                  averages.academicRecord > 0
                ) {
                  <p class="average">
                    <strong>Average grade:</strong>
                    {{ averages.academicRecord }}%
                  </p>
                }
              </section>
            </section>
          }
        </ng-container>
      </section>
    }

    @if (hasBursaryDocuments()) {
      <h2>Bursary documentation</h2>
      <mat-divider class="divider"></mat-divider>
      @if (contract) {
        <section class="documentation-buttons contract">
          <p class="invoices-payments contract-heading">Contract</p>
          <button
            mat-flat-button
            color="accent"
            (click)="viewDocument('Contract')"
          >
            View
          </button>
        </section>
      }
      @if (contract) {
        <mat-divider class="documentation-divider"></mat-divider>
      }
      @if (hasInvoices()) {
        <section>
          <p class="invoices-payments">Invoices</p>
          @for (invoice of getInvoices(); track invoice.type) {
            <section class="documentation-buttons expense-types">
              <p class="support-text">{{ invoice.label }}</p>
              <button
                mat-flat-button
                color="accent"
                (click)="viewDocument(invoice.type)"
              >
                View
              </button>
            </section>
          }
        </section>
      }
      @if (hasInvoices()) {
        <mat-divider class="documentation-divider"></mat-divider>
      }
      @if (hasPayments()) {
        <section>
          <p class="invoices-payments">Proof of payments</p>
          @for (payment of getPayments(); track payment.type) {
            <section class="documentation-buttons expense-types">
              <p class="support-text">{{ payment.label }}</p>
              <button
                mat-flat-button
                color="accent"
                (click)="viewDocument(payment.type, 'payment')"
              >
                View
              </button>
            </section>
          }
        </section>
      }
    }

    <h2>Personal documentation</h2>
    <mat-divider class="divider"></mat-divider>
    @if (hasDocument("Proof of Identification")) {
      <section class="btn-tile">
        <section class="doc-type-view">
          <p class="support-text">Proof of Identification</p>
          <button
            mat-flat-button
            color="accent"
            (click)="viewDocument('Proof of Identification')"
          >
            View
          </button>
        </section>
        <section class="calculated-average"></section>
      </section>
    }
    @if (hasDocument("Financial Statement")) {
      <section class="btn-tile">
        <section class="doc-type-view">
          <p class="support-text">Financial Statement</p>
          <button
            mat-flat-button
            color="accent"
            (click)="viewDocument('Financial Statement')"
          >
            View
          </button>
        </section>
        <section class="calculated-average"></section>
      </section>
    }
  </section>
</main>
